<template>
  <li v-bind:style="paddingLeft">
    <div class="treeview-item" :class="[ item.checked ? 'treeview-item-selected' : 'treeview-item-unselected' ]">
      <div v-if="item[childrenField]" class="treeview-item-group d-flex align-items-center">
        <b-link href="#"
                tabindex="-1"
                @click="toggle">
          <i v-if="! hasSlotName && this.open" class="fas fa-angle-down treeview-item-icon"></i>
          <i v-else-if="! hasSlotName" class="fas fa-angle-right treeview-item-icon"></i>
        </b-link>
        <input type="checkbox"
               ref="fatherCheckbox"
               class="mr-1"
               style="cursor:pointer"
               name="cbxAction"
               :indeterminate.prop="indeterminate(item)"
               :checked.prop="checked(item)"
               v-if="showCheckbox"
               v-on:change="propagate">
        <b-link href="#"
                tabindex="-1"
                class="text-default"
                @click="toggle"
                v-b-popover="tooltip">
          <i v-if="iconBeforeName(item)" :class="iconBeforeName(item)" class="text-default treeview-item-icon"></i>
          <span ref="txtItem" v-if="! hasSlotName">{{ serializer(item) }}</span>
          <slot></slot>
        </b-link>
      </div>
      <div class="text-default treeview-item-group d-flex align-items-center" v-else>
        <i class="far fa-circle treeview-item-icon" style="font-size: 4px;"></i>
        <input type="checkbox"
               class="mr-1"
               style="cursor:pointer"
               name="cbxAction"
               v-model="item[checkboxField]"
               v-if="showCheckbox"
               v-on:change="onSelectItem(item)">
        <i v-if="iconBeforeName(item)" :class="iconBeforeName(item)" class="treeview-item-icon"></i>
        <span ref="txtItem" class="ml-1" v-b-popover="tooltip" >{{ serializer(item) }}</span>
        <slot></slot>
      </div>
    </div>
    <ul class="pl-3" v-if="item[childrenField] && open === true">
      <tree-view-item v-for="subitem in item[childrenField]"
        ref="treeviewItem"
        :key="subitem[idField]"
        :item="subitem"
        :father="item"
        :startOpen="startOpen"
        :showCheckbox="showCheckbox"
        :serializer="serializer"
        :childrenField="childrenField"
        :iconBeforeName="iconBeforeName"
        v-on:selectitem="onSelectItem"
        v-on:open="doOpen"
        v-on:addtotypeahead="onAddToTypeahead" >
      </tree-view-item>
    </ul>
  </li>
</template>

<script>
import TreeViewItem from './TreeViewItem.vue'

export default {
  name: 'TreeViewItem',
  data () {
    return {
      paddingLeft: 'padding-left: ' + this.item.level + '0px',
      open: this.startOpen,
      tooltip: {
        content: this.serializer(this.item),
        boundary: 'viewport',
        boundaryPadding: 10,
        trigger: 'hover',
        placement: 'topright'
      }
    }
  },
  props: {
    item: {type: Object, required: true},
    father: {type: Object, required: false},
    startOpen: {type: Boolean, required: false, default: false},
    showCheckbox: {type: Boolean, required: false, default: false},
    serializer: {type: Function, required: true},
    childrenField: {type: String, required: false, default: 'children'},
    checkboxField: {type: String, required: false, default: 'checked'},
    idField: {type: String, required: false, default: 'id'},
    iconBeforeName: {type: Function, required: false, default: () => ''}
  },
  components: {
    TreeViewItem
  },
  mounted () {
    this.tooltip.disabled = this.$refs.txtItem ? this.$refs.txtItem.parentElement.parentElement.offsetWidth === this.$refs.txtItem.parentElement.parentElement.scrollWidth : true
  },
  computed: {
    hasSlotName () {
      return this.$slots.default && this.$slots.default.length > 0
    }
  },
  methods: {
    closeAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.closeAll()
        })
      }
      this.open = false
    },
    openAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.openAll()
        })
      }
      this.open = true
    },
    onSelectItem (item) {
      this.$emit('selectitem', item)
    },
    onAddToTypeahead (item) {
      this.$emit('addtotypeahead', item)
    },
    addToTypeahead (item) {
      this.$emit('addToTypeahead', item)
    },
    doOpen (item) {
      this.open = true
      this.$emit('open', item)
    },
    toggle () {
      if (!this.open) {
        this.$emit('open', this.item)
        this.open = true
      } else {
        this.closeAll()
      }
      // this.open = !this.open
    },
    indeterminate (item) {
      if (item[this.childrenField]) {
        let checked = 0
        let count = 0

        const setChecked = (it) => {
          if (it[this.childrenField]) {
            it[this.childrenField].forEach(c => setChecked(c))
          } else {
            count++
            if (it.checked) {
              checked++
            }
          }
        }

        setChecked(item)

        return checked > 0 && checked < count
      }
      return false
    },
    checked (item) {
      if (item[this.childrenField]) {
        let checked = true

        const setChecked = (it) => {
          if (it[this.childrenField]) {
            it[this.childrenField].forEach(c => setChecked(c))
          } else {
            checked = checked && it.checked
          }
        }

        setChecked(item)

        return checked
      }
      return false
    },
    selectAll (columns) {
      this.$emit('selectall', columns)
    },
    propagate (event) {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach((t) => {
          t.propagate(event)
        })
      } else {
        this.$set(this.item, 'checked', event.target.checked)
        this.$emit('selectitem', this.item)
      }
    }
  }
}
</script>

<style scoped>
.treeview-item-group {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.treeview-item-icon {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/treeview/TreeViewItem.vue